import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements';
import CreatePlanForm from './CreatePlan';
import config from '../../../src/config';

const PlanForm = injectStripe(CreatePlanForm);

const AdminTabs = ({ orgId, activeTab }) => {
  const navItems = [
    { title: 'Billing', tabName: 'billing', url: `/admin/organization/${orgId}/billing`},
    { title: 'Plan', tabName: 'plan', url: `/admin/organization/${orgId}/plan` },
  ];

  const tabClasses = tabName => {
    return classNames({
      'nav-link': true,
      active: tabName === activeTab,
    });
  };

  return (
    <ul className="nav nav-pills clearfix" style={{ paddingBottom: 10 }}>
      {navItems.map(item => (
        <Link
          key={item.title}
          className={tabClasses(item.tabName)}
          to={item.url}
        >
          {item.title}
        </Link>
      ))}
    </ul>
  );
};
AdminTabs.propTypes = {
  activeTab: PropTypes.string,
};

const queryOrganization = gql`
  query Organization($id: ID!) {
    organization(id: $id) {
      id
      name
    }
  }
`;

const withData = graphql(queryOrganization, {
  options: ({ params }) => ({
    variables: {
      id: params.organizationId,
    },
    fetchPolicy: 'network-only',
  }),
});

@withData
// @connect()
export default class Organization extends React.Component {
  render() {
    const { data: { organization } } = this.props;
    console.log('ddddd', this.props);
    if (!organization) return null;
    return (
      <div>
        <h2>Plan</h2>
        <StripeProvider apiKey={config.stripeKey.public}>
          <Elements>
            <PlanForm />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/OrganizationPlan.js